/**
 * @description
 * @author librajt
 */

import Api from '../../path';
import { fetchData, fetchDataSync } from '@umu/umu-fetch';

interface IInput {
    homework_session_id: number;
    type: number; // 0全部，1只看讲师，2获取单人数据
    minute_time?: number; // 分页按照每分钟来取，从1开始
    student_id?: number; // 获取单人的点评数据，传 student_id
}

export interface ISeed {
    goods_level: number;
    goods_random_seed: number;

    goods_comment_level: number;
    goods_comment_random_seed: number;

    normal_comment_level: number;
    normal_comment_random_seed: number;

    improve_level: number;
    improve_random_seed: number;

    improve_comment_level: number;
    improve_comment_random_seed: number;
}

export interface ISeedCount {
    comment_num: number; // 点评人数
    goods_num: number; // 非常棒数量
    improve_num: number; // 待改进数量
    text_num: number; // 文字点评数量
    voice_num: number; // 语音点评数量
}

export interface IOutput {
    data_count: ISeedCount;
    level: {
        max_praise_level: number;
        max_comment_level: number;
        max_normal_comment_level: number;
    };
    list: ISeed[];
}

export const getTimelineStatList = fetchDataSync((data: IInput): Promise<IResponse<IOutput>> => {
    return fetchData(Api.TIMELINE_STAT_LIST, data).then((res: IResponse<IOutput>) => {
        return res;
    });
});